import { Component, Inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { BaseModalComponent } from "../base-modal/base-modal.component";

/** One live announcement's worth of content - see UpdateCompleteModalService. Each list
 * is independent and only renders when it has at least one entry. */
export interface DialogUpdateCompleteAnnouncement {
  version: string;
  newFeatures: string[];
  bugFixes: string[];
}

/** FLIP-79, extended by FLIP-332 to accumulate every version a user has skipped rather
 * than just the newest. `announcements` is always non-empty and ordered oldest first;
 * `latestVersion` is the highest version among them, shown in the modal's opening line. */
export interface DialogUpdateCompleteData {
  latestVersion: string;
  announcements: DialogUpdateCompleteAnnouncement[];
}

/**
 * "You're up to date!" / What's New modal, shown once per version per user (see
 * UpdateCompleteModalService for the seen-tracking). Built directly on app-base-modal,
 * same approach as FLIP-78's dialog-refresh.component.ts, for the Figma-specified
 * sundown -> parchment gradient and wisteria Close pill that the fixed
 * ConfirmationModalComponent wrapper doesn't support.
 */
@Component({
  selector: "app-dialog-update-complete",
  templateUrl: "./dialog-update-complete.component.html",
  styleUrls: ["./dialog-update-complete.component.scss"],
  standalone: true,
  imports: [CommonModule, BaseModalComponent],
})
export class DialogUpdateCompleteComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogUpdateCompleteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogUpdateCompleteData
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
